import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const addWishlist = async (d) => {
  try {
    return await postData(`/wishlist/add`, {
      product_id: d?.product_id,
      variant_id: d?.variant_id,
    });
  } catch (error) {
    console.log(error);
  }
};

export const getWishlist = async (selectedOption) => {
  try {
    return await getData(`/wishlist/show?selectedOption=${selectedOption}`);
  } catch (error) {
    console.log(error);
  }
};
